'use strict';

import {makeActionCreator} from '../../core-utilities/redux';
import {AUTH_DATA_PREFIX} from '../redux/state';

const INIT_AUTH = '@@auth/INIT_AUTH';
const INIT_AUTH_ERROR = '@@auth/INIT_AUTH_ERROR';
const INIT_AUTH_COMPLETE = '@@auth/INIT_AUTH_COMPLETE';
const STATE_GO_POST_AUTH = '@@auth/STATE_GO_POST_AUTH';

/**
 *
 * @return {ReduxAction}
 */
export const initAuth = makeActionCreator(AUTH_DATA_PREFIX, 'INIT_AUTH');

/**
 * Auth init is complete when we are logged in from cached data, or know that we cannot.
 * The app may properly start.
 * @param {?Error} err
 * @param {?String} userId
 * @param {String} completedBy - debug information
 * @return {ReduxAction}
 */
export function initAuthComplete(err, userId, completedBy) {
  return {
    type: INIT_AUTH_COMPLETE,
    payload: {
      err,
      userId,
      completedBy,
    },
  };
}
initAuthComplete.TYPE = INIT_AUTH_COMPLETE;

/**
 * Catastrophic Error.
 * Restart App.
 * @param {Error} err
 * @return {ReduxAction}
 */
export function initAuthError(err) {
  return {
    type: INIT_AUTH_ERROR,
    payload: {
      err,
    },
  };
}
initAuthError.TYPE = INIT_AUTH_ERROR;

/**
 *
 * @param {String} toState
 * @param {?Object} [toParams]
 * @return {ReduxAction}
 */
export function stateGoPostAuth(toState, toParams) {
  return {
    type: STATE_GO_POST_AUTH,
    payload: {
      toState,
      toParams,
    },
  };
}
stateGoPostAuth.TYPE = STATE_GO_POST_AUTH;

export const hydrateProfile = makeActionCreator(AUTH_DATA_PREFIX, 'HYDRATE_PROFILE');



// WEBPACK FOOTER //
// ./src/js/auth/actions/config.js